import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-lg text-textPrimary" }, "Desligar \"ocupado sem identificação\"?", -1)
const _hoisted_2 = {
  class: "flex flex-col gap-3 px-4 py-4 md:px-6 text-left text-sm text-textPrimary",
  "data-testid": "disable-unidentified-body"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Os plantões já marcados continuam ocupados sem identificação. Novas marcações ficam bloqueadas. ", -1)
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = {
  class: "rounded-md bg-gray-100 px-3 py-2 font-bold",
  "data-testid": "disable-unidentified-future"
}
const _hoisted_6 = {
  class: "rounded-md bg-gray-100 px-3 py-2",
  "data-testid": "disable-unidentified-past"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-start gap-2 cursor-pointer"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs text-[#68688D]" }, " Opcional. O responsável é removido e eles entram nas métricas de vaga. Os passados nunca são alterados. ", -1)
const _hoisted_9 = { class: "flex justify-end gap-3 w-full p-4" }

import { ref, watch } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DisableUnidentifiedCoverageModal',
  props: {
    showModal: { type: Boolean },
    futureCount: {},
    pastCount: {}
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit }) {

const props = __props;




// Q30-A: o atalho nasce DESMARCADO a cada abertura.
const releaseFuture = ref(false)
watch(
  () => props.showModal,
  (open) => {
    if (open) releaseFuture.value = false
  }
)

const formatCount = (value: number) => value.toLocaleString('pt-BR')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: _ctx.showModal,
    hasHeaderBorder: true,
    hasFooterBorder: true,
    noBodyPadding: true,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('cancel')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(OutlineButton, {
          height: "48px",
          color: "grey",
          "data-testid": "disable-unidentified-cancel",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancelar")
          ]),
          _: 1
        }),
        _createVNode(FilledButton, {
          height: "48px",
          color: "negative",
          "data-testid": "disable-unidentified-confirm",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm', releaseFuture.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Desligar")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(formatCount(_ctx.futureCount)) + " futuros", 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(formatCount(_ctx.pastCount)) + " passados (não mudam)", 1)
        ]),
        (_ctx.futureCount > 0)
          ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((releaseFuture).value = $event)),
                type: "checkbox",
                class: "mt-1",
                "data-testid": "disable-unidentified-release-future"
              }, null, 512), [
                [_vModelCheckbox, releaseFuture.value]
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("b", null, "Liberar os " + _toDisplayString(formatCount(_ctx.futureCount)) + " futuros como vaga aberta", 1),
                _hoisted_8
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})